import { BaseMediaService } from '../../base-media.service';
import { DocumentSaveResponseDto } from '../dto/response/document-save-response';

class DocumentService extends BaseMediaService {
  public async saveDocument(
    document: FormData
  ): Promise<DocumentSaveResponseDto> {
    const response = await this.post<DocumentSaveResponseDto>(
      `/document`,
      document,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  }

  public async deleteDocument(fileName: string): Promise<void> {
    await this.delete<void>('/document', {
      params: {
        fileName,
      },
    });
  }
}

const documentService = new DocumentService();
export default documentService;
